import { render, staticRenderFns } from "./ModalVisualizarDetalhesAlertaSocioambiental.vue?vue&type=template&id=08c98e4e&scoped=true&lang=pug"
import script from "./ModalVisualizarDetalhesAlertaSocioambiental.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarDetalhesAlertaSocioambiental.vue?vue&type=script&lang=js"
import style0 from "./ModalVisualizarDetalhesAlertaSocioambiental.vue?vue&type=style&index=0&id=08c98e4e&prod&lang=scss&scoped=true"
import style1 from "./ModalVisualizarDetalhesAlertaSocioambiental.vue?vue&type=style&index=1&id=08c98e4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c98e4e",
  null
  
)

export default component.exports